<template>
  <div class="home_box">
    <el-container>
      <!-- 左侧 -->
      <el-aside width="220px">
        <Left></Left>
      </el-aside>
      <!-- 右侧 -->
      <el-container>
        <el-header>
          <Top></Top>
        </el-header>
        <el-main>
          <router-view></router-view>
        </el-main>


      </el-container>
    </el-container>
  </div>
</template>

<script>
  import Left from "@/components/Left.vue";
  import Top from "@/components/Top.vue";
  export default {
    components: {
      Left,
      Top
    }
  };
</script>

<style lang="less" scoped>
  body {
    margin: 0;

    .el-container {
      .el-aside {
        overflow: hidden;
        background-color: #314158;
      }

      .el-header {
        padding: 0;
      }

      .el-main {
        width: 100%;
        min-height: 1200px;
        padding: 30px;

        
      }
    }
  }
</style>